// Copyright (c) 2022 by Move Closer

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface AddressData {
  id?: number
  company: string | null
  countryCode: string
  city: string
  defaultBilling?: boolean
  defaultShipping?: boolean
  firstName: string
  lastName: string
  postalCode: string
  phoneNumber: string
  street: string
  vatId?: string
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum AddressType {
  Billing = 'billing',
  Shipping = 'shipping'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface RequestDataChangePayload {
  data?: AddressData
  default: boolean
  type?: string
}

/**
 * TODO: Add additional property if necessary
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export type DeliveryAddressData = AddressData

/**
 * TODO: Add additional property if necessary
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export type BillingAddressData = AddressData
